module.exports = __webpack_public_path__ + "static/media/signature-pad-logo.27ffd70b.png";